interface ProductionDataUnavailableProps {
  feature: string;
  requiredSources: string;
}

export function ProductionDataUnavailable({
  feature,
  requiredSources,
}: ProductionDataUnavailableProps) {
  return (
    <div className="flex h-full items-center justify-center p-8">
      <div
        className="max-w-xl rounded-panel border border-[#f3c4c4] bg-[#fff7f7] px-6 py-5"
        role="status"
        data-source-status="not-authoritative"
      >
        <p className="font-display text-base font-bold text-ink">
          {feature} indisponible
        </p>
        <p className="mt-2 text-sm text-muted">
          Aucune donnée synthétique n'est affichée en production. Cette fonction
          sera activée après raccordement et validation des sources suivantes :
          {' '}{requiredSources}.
        </p>
        <p className="mt-2 text-xs font-semibold text-[#b42318]">
          Statut source : non autoritative — fallback synthétique refusé
        </p>
      </div>
    </div>
  );
}
